import React from 'react';
import CommonBanner from '../component/Common/CommonBanner'
import WhyWeExist from '../component/Home/WhyWeExist';
import HeartbeatSection from '../component/Home/HeartbeatSection'
const WhyWeExistPage = () => {

    return (
        <>
            <CommonBanner heading="Why We Exist" pagination="Why We Exist" />
            <WhyWeExist />
                   <HeartbeatSection/>
        </>
    );
};

export default WhyWeExistPage;
